const firebaseConfig = {
  apiKey: "AIzaSyAAwXMaT4rpAe1UEOER4D3Kd8OBS8TJFHU",
  authDomain: "light-of-islam-b3d23.firebaseapp.com",
  projectId: "light-of-islam-b3d23",
  storageBucket: "light-of-islam-b3d23.appspot.com",
  messagingSenderId: "12182074465",
  appId: "1:12182074465:web:c487af24de56f97216a620",
};
export default firebaseConfig;
